import React, { useCallback, useEffect, useState } from 'react';
import {
  Box,
  Card,
  InputAdornment,
  TextField,
  Typography,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { getUsers } from '../../../services/UserService';
import PaginationComponent from '../../../components/Pagination/Pagination';
import EmployeePrivilegeUpdate from './EmployeePrivilegeUpdate';
import { WEEKEND_WORKING_PRIVILEGE } from '../../../pages/WeekendWorking/weekendUtils';

const PAGE_SIZE = 10;

/** Admin: switch Weekend Working Hours on or off per employee. */
const WeekendWorkingPrivileges = () => {
  const [query, setQuery] = useState('');
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const load = useCallback(async () => {
    const res = await getUsers(query.trim(), PAGE_SIZE, page - 1, 'ACTIVE');
    if (res.isError === false) {
      setUsers(res.data?.content || []);
      setTotalPages(Math.max(res.data?.totalPages || 1, 1));
    }
  }, [query, page]);

  useEffect(() => {
    const timer = setTimeout(load, 250);
    return () => clearTimeout(timer);
  }, [load]);

  return (
    <Box sx={{ p: { xs: 1, md: 2 } }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          mb: 2,
          flexWrap: 'wrap',
        }}
      >
        <Typography variant="h6" sx={{ mr: 'auto' }}>
          Weekend Working Hours access
        </Typography>
        <TextField
          size="small"
          placeholder="Search employee"
          value={query}
          onChange={(e) => {
            setQuery(e.target.value);
            setPage(1);
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      {users.length === 0 && (
        <Typography color="text.secondary">No employees found.</Typography>
      )}

      {users.map((user) => (
        <Card
          key={user.id}
          variant="outlined"
          sx={{
            mb: 2,
            p: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 1,
          }}
        >
          <Box>
            <Typography variant="h6">
              {user.firstName}
              {user.lastName ? ` ${user.lastName}` : ''}
            </Typography>
            <Typography color="text.secondary">
              Employee Code :- {user.employeeCode}
            </Typography>
          </Box>
          <EmployeePrivilegeUpdate
            user={user}
            privilegeKey={WEEKEND_WORKING_PRIVILEGE}
            label="Request Weekend Working Hours"
          />
        </Card>
      ))}

      {totalPages > 1 && (
        <PaginationComponent
          count={totalPages}
          page={page}
          pageChange={(e, value) => setPage(value)}
        />
      )}
    </Box>
  );
};

export default WeekendWorkingPrivileges;
